// extracted by mini-css-extract-plugin
export default {"bloco":"ChipsComOutro_bloco__T-VXS"};